import './Services.scss'
import React, { useEffect, useRef, useState } from 'react'

const services = [
    {
        id: 'sites',
        number: '01',
        title: 'Sites vitrines & boutiques',
        text: 'Sites vitrines et boutiques e-commerce sur mesure — React, WordPress ou Shopify selon vos besoins réels, pas par défaut.',
        label: 'Fonctionnalités du service sites et boutiques sur mesure',
        items: [
            <>Développement sur mesure (<strong>React, WordPress, Shopify</strong>)</>,
            <><strong>Back-office</strong> personnalisé</>,
            <><strong>Refonte ou amélioration</strong> d’un site existant</>,
        ],
    },
    {
        id: 'erp',
        number: '02',
        title: 'ERP & outils de gestion',
        tag: 'Site + ERP',
        text: 'Je conçois des ERP sur mesure et je les relie à votre site vitrine ou à votre boutique : commandes, stocks, clients et facturation circulent sans ressaisie.',
        label: 'Fonctionnalités du service ERP et outils de gestion',
        items: [
            <><strong>ERP sur mesure</strong> relié à votre site</>,
            <>Connexion <strong>site, e-commerce et gestion</strong></>,
            <><strong>Automatisation</strong> des tâches répétitives</>,
        ],
    },
    {
        id: 'diagnostic',
        number: '03',
        title: 'Diagnostic & architecture',
        text: 'J’analyse votre site, vos outils et votre organisation pour identifier ce qui mérite une expertise technique — et vous livre une feuille de route claire et priorisée.',
        label: 'Fonctionnalités du service diagnostic et architecture',
        items: [
            <><strong>Audit technique</strong> et fonctionnel de l’existant</>,
            <>Recommandations d’<strong>architecture priorisées</strong></>,
            <><strong>Cadrage budgétaire</strong> avant développement</>,
        ],
    },
]

function Services({ only, headerMode = 'full' }) {
    const shown = only === undefined
        ? services.map((service, index) => [service, index])
        : [[services[only], only]]

    const gridRef = useRef(null)
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting)
            },
            {
                root: null,
                threshold: 0,
                rootMargin: '0px 0px -50px 0px'
            }
        )

        const grid = gridRef.current

        if (grid) {
            observer.observe(grid)
        }

        return () => {
            if (grid) {
                observer.unobserve(grid)
            }
        }
    }, [])

    const isFull = headerMode === 'full'

    return (
        <section
            id={isFull ? 'services' : undefined}
            className="services"
            aria-labelledby={isFull ? 'services-title' : undefined}
            aria-label={isFull ? undefined : 'Comment je peux vous aider'}
        >
            <div className="services__container">
                {isFull && (
                    <header className="services__header">
                        <h2 id="services-title" className="services__title">
                            Comment je peux vous aider
                        </h2>

                        <p className="services__intro">
                            Du site vitrine à l’ERP relié à vos outils, en
                            passant par un diagnostic technique.
                        </p>
                    </header>
                )}

                {headerMode === 'eyebrow' && (
                    <p className="sectionEyebrow">Comment je peux vous aider</p>
                )}

                <div
                    ref={gridRef}
                    className={`services__grid ${isVisible ? 'visible' : ''}`}
                >
                    {shown.map(([service, index]) => (
                        <article
                            key={service.id}
                            className={`services__card services__card--${index + 1}`}
                        >
                            <p className="services__card-number">
                                {service.number}
                                {service.tag && (
                                    <span className="services__card-tag">{service.tag}</span>
                                )}
                            </p>

                            <h3 className="services__card-title">{service.title}</h3>

                            <p className="services__card-text">{service.text}</p>

                            <ul className="services__card-list" aria-label={service.label}>
                                {service.items.map((item, i) => (
                                    <li key={i}>{item}</li>
                                ))}
                            </ul>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Services
